import classNames from "classnames";

type AccessibilitySkipLinkProps = {
    linkHref?: string;
    linkText?: string;
    displayHelpLink?: boolean;
    isGlobalSkipLink?: boolean;
};

/**
 * Renders the "Skip to Content" accessibility links
 *
 * @param {string} linkHref - The href for the linkText - default: "#content"
 * @param {string} linkText - The text to display in the link - default: "Skip to Main Content"
 * @param {boolean} displayHelpLink - Flag to display the Accessibility Help link
 * @param {boolean} isGlobalSkipLink - Flag to offset link height for global accessibility links
 * @returns {React.Component} The AccessibilitySkipLink component
 */
export function AccessibilitySkipLink({
    linkHref = "#content",
    linkText = "Skip to Main Content",
    displayHelpLink,
    isGlobalSkipLink,
}: AccessibilitySkipLinkProps) {
    const classes = classNames("accessibilityLinks", {
        globalSkipLink: isGlobalSkipLink,
    });

    return (
        <div className={classes}>
            <a className="accessibilitySkipLink" href={linkHref}>
                {linkText}
            </a>
            {displayHelpLink && (
                <a className="accessibilityHelpLink" href="/accessibility">
                    Accessibility Help
                </a>
            )}
        </div>
    );
}

export default AccessibilitySkipLink;
